import axios from 'axios'
import fileDownload from 'js-file-download'

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
  getTransferOutbounds({ commit }, params = {}) {
    return axios.get('/transfer-outbounds/search', { params })
  },
  getTransferOutbound({ commit }, id) {
    return axios.get(`/transfer-outbounds/${id}`)
  },
  createTransferOutbound({ commit }, data) {
    return axios.post('/transfer-outbounds', data)
  },
  updateTransferOutbound({ commit }, data) {
    return axios.put(`/transfer-outbounds/${data.id}`, data)
  },
  confirmDelivered({ commit }, data) {
    return axios.post(`/transfer-outbounds/${data.id}/delivered`, data)
  },
  downloadOutBound({ commit }, data) {
    return axios
      .get(`/transfer-outbounds/${data.id}/download`, { responseType: 'blob' })
      .then((response) => {
        fileDownload(response.data, `${data.document_name}.pdf`)
      })
  },
  updateTransferOutboundStatus({ commit }, data) {
    return axios.put(`/transfer-outbounds/${data.id}/change-status`, data)
  },
  sendTransferOutbound({ commit }, data) {
    return axios.post(`/transfer-outbounds/${data.id}/sending`, data.params)
  },
  receiveTransferOutbound({ commit }, data) {
    return axios.post(`/transfer-outbounds/${data.id}/received`, data.params)
  },
  rejectTransferOutbound({ commit }, data) {
    return axios.post(`/transfer-outbounds/${data.id}/rejected`, data.params)
  },
  returnOutbound({ commit }, data) {
    const payload = {... data}
    if (! Object.prototype.hasOwnProperty.call(payload, 'is_check')){
      payload.is_check = 1
    }
    return axios.post(`/transfer-outbounds/${payload.id}/return-orders`, payload)
  },
  deleteOutbound({ commit }, data) {
    const payload = {... data}
    if (! Object.prototype.hasOwnProperty.call(payload, 'is_check')){
      payload.is_check = 1
    }
    return axios.post(`/transfer-outbounds/${payload.id}/delete`, payload)
  },
  reorderTransferOutbound({ commit }, data) {
    return axios.post(`/transfer-outbounds/${data.id}/reorder`, data.params)
  }
}
